'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const TickIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="TickIcon">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2164_6004)">
          <path
            d="M12.9693 0.85236C12.8857 0.791541 12.7909 0.747891 12.6904 0.723934C12.5898 0.699977 12.4855 0.696188 12.3835 0.712787C12.2815 0.729385 12.1837 0.766041 12.0959 0.820636C12.0082 0.875231 11.9321 0.946683 11.8721 1.03086L4.50633 11.3051L2.04408 8.84286C1.8948 8.70376 1.69735 8.62803 1.49333 8.63163C1.28932 8.63523 1.09466 8.71787 0.95038 8.86216C0.806096 9.00644 0.723449 9.2011 0.719849 9.40511C0.71625 9.60913 0.791979 9.80658 0.931083 9.95586L4.04433 13.0744C4.12648 13.1527 4.22429 13.2127 4.33131 13.2504C4.43834 13.2882 4.55215 13.3028 4.66524 13.2934C4.77834 13.284 4.88815 13.2507 4.98745 13.1957C5.08675 13.1408 5.17328 13.0654 5.24133 12.9746L13.1531 1.94961C13.2136 1.86571 13.2569 1.77062 13.2805 1.66986C13.304 1.56911 13.3074 1.46468 13.2903 1.36262C13.2732 1.26057 13.236 1.16292 13.1809 1.07533C13.1258 0.987747 13.0539 0.911959 12.9693 0.85236Z"
            fill={sx?.color || '#3D517B'}
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

TickIcon.propTypes = {
  sx: PropTypes.object
}
